// 188 -- Zod schemas for the enrollment-request endpoints (parent submit +
// optional indemnity, coach approve/decline).

import { z } from "zod";

// Parent submits a child into a sport at a school. Sport only -- the coach
// assigns the team at approval. Indemnity may ride along on submit or be set
// later via the same shape (all indemnity fields optional).
export const submitEnrollmentRequestSchema = z.object({
  school_id: z.string().min(1, "School is required"),
  sport_id: z.string().min(1, "Sport is required"),
  indemnity_complete: z.boolean().optional(),
  indemnity_document_url: z.string().max(2000).nullable().optional(),
});

export type SubmitEnrollmentRequestInput = z.infer<typeof submitEnrollmentRequestSchema>;

// Parent updates the indemnity state on a pending request.
export const updateEnrollmentIndemnitySchema = z.object({
  indemnity_complete: z.boolean().optional(),
  indemnity_document_url: z.string().max(2000).nullable().optional(),
});

export type UpdateEnrollmentIndemnityInput = z.infer<typeof updateEnrollmentIndemnitySchema>;

// Coach approves the request and places the child in one of their teams.
export const approveEnrollmentRequestSchema = z.object({
  team_id: z.string().min(1, "A team is required to approve"),
});

export type ApproveEnrollmentRequestInput = z.infer<typeof approveEnrollmentRequestSchema>;

// Coach declines, optionally with a reason shown to the parent.
export const declineEnrollmentRequestSchema = z.object({
  reason: z.string().max(500).nullable().optional(),
});

export type DeclineEnrollmentRequestInput = z.infer<typeof declineEnrollmentRequestSchema>;
